/**
 * processNode模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const processNode = {
  // 创建
  createProcessNode(params) {
    return $http.post(`${global.API_URL}/sme/processNode/create`,params);
  },
  // 编辑
  updateProcessNode(params) {
    return $http.post(`${global.API_URL}/sme/processNode/update`,params);
  },
  // 分页
  pageProcessNode(params) {
    return $http.post(`${global.API_URL}/sme/processNode/page`,params);
  },
  // 删除
  deleteProcessNode(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/processNode/delete`,param);
  },
  // 根据公司查询节点
  queryNodesByCompanyId(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/processNode/queryNodesByCompanyId`,param);
  }
}

export default processNode;



// WEBPACK FOOTER //
// ./src/api/processNode.js